import React from 'react';
import ModalUI from "../ModalsUI/index";
import HeaderBillboards from '../HeadersUI/HeaderBillboards';
import BillboardFooter from '../BillboardUI/BillboardFooter';
import VariantSwitchSideBar from "../VariantSwitchUI/VariantSwitchSideBar";

export default function BillboardVariantSwitchDisplay() {
    return (
        <React.Fragment>
            <HeaderBillboards />
            <VariantSwitchSideBar />
            <BillboardFooter/>
            <ModalUI />
        </React.Fragment>
    )
}